import React from 'react'
import {NavLink} from 'react-router-dom';
import Logo from '../images/logo2.jpeg';
function Home() {
    return (
        <div style={{width:"100%",height:"150vh",backgroundColor:"black",display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column",}} className="conatiner">
            <h1 id="cont">INTRODUCING GRADING ON THE BLOCKCHAIN</h1>
            <h2 className="content1" >EGS Grading by Elite Game Spot ​is a new, more elaborate grading service, that gives
it's clients more answers than questions.</h2>
            <img style={{width:"30%"}} src={Logo} alt="Not found"></img>
            <h2 className="content2">​If your card comes back less than Gem Mint, we will not just tell you, but show you why
Using our Patent Pending Zone Grading System.</h2>
        <NavLink className="btn2" to="/register"  >Register Asset Now</NavLink>
        </div>
    )
}

export default Home
